const getWeekdayOfDate = (date) => {
    const weekday = [
        'Chủ nhật',
        'Thứ hai',
        'Thứ ba',
        'Thứ tư',
        'Thứ năm',
        'Thứ sáu',
        'Thứ bảy',
    ];
    const n = weekday[date.getDay()];
    return n;
};

export { getWeekdayOfDate };
